/**
 * Global abbreviations for email HTML/CSS minification.
 * Block-specific abbreviations live in their respective block directories
 * (e.g., shoppable-products/selectors.ts).
 */
export enum Abbrv {
  // cspell:disable
  HIDDEN = "hd",
  HIDDEN_FOCUSABLE = "hf",
  SELECT = "sl",

  REVIEW_REQUEST = "rr",
  REVIEW_TITLE = "rr-title",
  REVIEW_DESCRIPTION = "rr-desc",
  REVIEW_STAR_RATING = "rr-star",
  REVIEW_PRODUCT_ID = "rr-pid",

  EMAIL_ID = "emlid",
  EMAIL = "eml",
  FIRST_NAME = "fnm",
  LAST_NAME = "lnm",

  SUBSCRIPTION_SKIP_OR_DELAY = "ssd",
  BYPASS_INITIAL_SCREEN = "bis",
  ACTION_TYPE_SKIP = "ats",
  ACTION_TYPE_DELAY = "atd",
  DELAY_TIME_UNIT = "dtu",
  DELAY_VALUE = "dv",

  FULL_WIDTH_BUTTON = "fwb",
  // cspell:enable
}
